import { create } from 'zustand';
import type { DictationResult } from '@/lib/api/consultations';

/**
 * Bridge between the open consultation and the global AI assistant, so the one floating assistant
 * can expose the nurse's consultation powers (brief, dictation → clinical proposals) without a second
 * button. The consultation page registers itself here on mount and clears it on unmount.
 */
interface ConsultAssistantState {
  consultationId: string | null;
  readOnly: boolean;
  onDictation: ((r: DictationResult) => void) | null;
  setConsult: (v: { consultationId: string; readOnly: boolean; onDictation: (r: DictationResult) => void }) => void;
  clear: () => void;
}

export const useConsultAssistant = create<ConsultAssistantState>((set) => ({
  consultationId: null,
  readOnly: false,
  onDictation: null,
  setConsult: ({ consultationId, readOnly, onDictation }) => set({ consultationId, readOnly, onDictation }),
  clear: () => set({ consultationId: null, readOnly: false, onDictation: null }),
}));
